// Display formatters for money and dates.
// Per CLAUDE.md:
//   - UI shows rupees with NO decimals (rounded to nearest rupee).
//   - PDFs/print show 2 decimals.
//   - Dates everywhere show as dd-MMM-yy (e.g., 19-May-26).

const MONTHS_SHORT = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];

/** Round to the nearest rupee and format with Indian thousands grouping. */
export function formatRupeesUI(value: number | string | null | undefined): string {
  if (value == null || value === '') return '';
  const n = typeof value === 'number' ? value : Number(value);
  if (!isFinite(n)) return '';
  return Math.round(n).toLocaleString('en-IN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}

/** Money with 2 decimals, for PDF/print contexts only. */
export function formatRupeesPrint(value: number | string | null | undefined): string {
  if (value == null || value === '') return '';
  const n = typeof value === 'number' ? value : Number(value);
  if (!isFinite(n)) return '';
  return n.toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/** Format any Date / ISO string as dd-MMM-yy (e.g., 19-May-26). */
export function formatDateDdMmmYy(d: Date | string | null | undefined): string {
  if (!d) return '';
  const dt = d instanceof Date ? d : new Date(d);
  if (isNaN(dt.getTime())) return '';
  const day = String(dt.getDate()).padStart(2, '0');
  const month = MONTHS_SHORT[dt.getMonth()];
  const year = String(dt.getFullYear()).slice(-2);
  return `${day}-${month}-${year}`;
}

/** Same as above but with 4-digit year, for documents/print where ambiguity matters. */
export function formatDateDdMmmYyyy(d: Date | string | null | undefined): string {
  if (!d) return '';
  const dt = d instanceof Date ? d : new Date(d);
  if (isNaN(dt.getTime())) return '';
  const day = String(dt.getDate()).padStart(2, '0');
  const month = MONTHS_SHORT[dt.getMonth()];
  return `${day}-${month}-${dt.getFullYear()}`;
}

/** Round a number to N decimal places without floating-point drift. */
export function roundTo(n: number, decimals: number = 2): number {
  const factor = Math.pow(10, decimals);
  return Math.round(n * factor) / factor;
}
